import { createSlice } from "@reduxjs/toolkit";

import { networkResponseAdapter } from "./response.adapter";

const networkResponsesSlice = createSlice({
  name: "networkResponses",
  initialState: networkResponseAdapter.getInitialState(),
  reducers: {
    addOne: networkResponseAdapter.addOne,
  },
});

export const { actions } = networkResponsesSlice;

export default {
  networkResponses: networkResponsesSlice.reducer,
};
